import Model from '@models/Model'

export default class Service extends Model {
  getSchema () {
    return {
      'portal': {
        type: Boolean
      },
      'current': {
        type: Boolean
      },
      'description': {
        type: String
      },
      'icon': {
        type: String
      },
      'id': {
        type: String
      },
      'name': {
        type: String
      },
      'url': {
        type: String
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Service/model.js